import { type RewardsCatalogSchedule } from 'types/api'
import { daysOfWeek } from 'utils/util'

export const addMissingDays = (schedules: RewardsCatalogSchedule[]) => {
  const allDays: RewardsCatalogSchedule[] = [
    {
      dayName: 'Monday',
      opening: '',
      closing: '',
    },
    {
      dayName: 'Tuesday',
      opening: '',
      closing: '',
    },
    {
      dayName: 'Wednesday',
      opening: '',
      closing: '',
    },
    {
      dayName: 'Thursday',
      opening: '',
      closing: '',
    },
    {
      dayName: 'Friday',
      opening: '',
      closing: '',
    },
    {
      dayName: 'Saturday',
      opening: '',
      closing: '',
    },
    {
      dayName: 'Sunday',
      opening: '',
      closing: '',
    },
  ]
  schedules.forEach((day) => {
    const indexToReplace = daysOfWeek.indexOf(day.dayName ?? '')
    allDays[indexToReplace] = day
  })
  return allDays
}
